module.exports = __webpack_public_path__ + "img/gourmet.ec68c277.gif";